module.exports = __webpack_public_path__ + "static/media/lead@2x.b28fb637.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_120/imgs/lead@2x.png
// module id = 1132
// module chunks = 0